import {
  MYEXAM,
  EXAMPAPER,
} from './types';
import {
  getMyExam,
  getExamination,
} from '../services/getData';

export default {
  [MYEXAM]({ commit }, id) {
    return getMyExam(id).then((result) => { // id是准考证
      commit(MYEXAM, result); // 提交一个mutation
      return result;
    });
  },
  [EXAMPAPER]({ commit }, id) { // ID 是准考证
    return getExamination(id).then((result) => {
      commit(EXAMPAPER, result); // 提交一个mutation
      return result;
    });
  },
};
